import { Component } from '@angular/core';

@Component({
  selector: 'app-trust-indicators',
  template: `
    <div class="trust-indicators">
      <div class="indicator">
        <i class="fa fa-shield-alt"></i>
        <h4>Verified Certificates</h4>
        <p>Industry-recognized certifications</p>
      </div>
      <div class="indicator">
        <i class="fa fa-user-tie"></i>
        <h4>Expert Instructors</h4>
        <p>10+ years industry experience</p>
      </div>
      <div class="indicator">
        <i class="fa fa-briefcase"></i>
        <h4>Job Assistance</h4>
        <p>Placement support guaranteed</p>
      </div>
      <div class="indicator">
        <i class="fa fa-clock"></i>
        <h4>Flexible Timings</h4>
        <p>Weekend & evening batches</p>
      </div>
      <div class="indicator">
        <i class="fa fa-rupee-sign"></i>
        <h4>EMI Available</h4>
        <p>Easy payment options</p>
      </div>
    </div>
  `,
  styles: [`
    .trust-indicators {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
      gap: 20px;
      padding: 40px 20px;
      max-width: 1200px;
      margin: 0 auto;
      background: white;
    }

    .indicator {
      text-align: center;
      padding: 20px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      transition: all 0.3s ease;
    }

    .indicator:hover {
      box-shadow: 0 4px 15px rgba(0,0,0,0.1);
      transform: translateY(-3px);
      border-color: #1976d2;
    }

    .indicator i {
      font-size: 36px;
      color: #1976d2;
      margin-bottom: 15px;
    }

    .indicator h4 {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin: 10px 0 5px;
    }

    .indicator p {
      font-size: 13px;
      color: #666;
      margin: 0;
    }
  `]
})
export class TrustIndicatorsComponent {}
